import type { ReactNode } from 'react'

interface ModalLayoutProps {
  children: ReactNode
  onClose: () => void
}

export default function CreateGalleryModal({ children, onClose }: ModalLayoutProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-70"
      onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
    >
      <div className="w-full max-w-lg bg-gray-900 rounded-2xl shadow-2xl flex flex-col max-h-[90vh]">
        <div className="flex flex-col gap-6 px-8 pt-8 pb-8 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  )
}
